import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_BEGIN,
  CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_SUCCESS,
  CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_FAILURE,
  CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function cloneCustomDataMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/custom-data-mapping/clone`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_SUCCESS,
            data: res.data,
          });
          toast.success('Cloned Successfully !');
          resolve(res);
        },

        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Failed to Clone !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCloneCustomDataMappingError() {
  return {
    type: CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_BEGIN:
      return {
        ...state,
        cloneCustomDataMappingPending: true,
        cloneCustomDataMappingError: null,
      };

    case CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_SUCCESS:
      return {
        ...state,
        cloneCustomDataMappingPending: false,
        cloneCustomDataMappingError: null,
        customDataMappings: [...state.customDataMappings, action.data],
      };

    case CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_FAILURE:
      return {
        ...state,
        cloneCustomDataMappingPending: false,
        cloneCustomDataMappingError: action.data.error,
      };

    case CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        cloneCustomDataMappingError: null,
      };

    default:
      return state;
  }
}
